import {createContext} from "react";
// Summ order
const CountContext  = createContext(null);
// Array for product
let CartContext = createContext([]);
const OrderContext = createContext(null)
export  { CountContext, CartContext, OrderContext };
